import Carousel from "./components/Carousel";
export { Pagination } from "./components/Pagination";

export type {
  TCarouselProps,
  ICarouselInstance,
  IComputedDirectionTypes,
  CarouselRenderItem,
} from "./types";
export type { TAnimationStyle } from "./components/ItemLayout";
export type { ILayoutConfig } from "./layouts/stack";

export default Carousel;
